import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { LayoutType } from '../models/layout-config';

@Injectable({
  providedIn: 'root',
})
export class LayoutService {
  private layoutSubject = new BehaviorSubject<LayoutType>('classic');
  layout$ = this.layoutSubject.asObservable();

  get layoutType(): LayoutType {
    return this.layoutSubject.value;
  }

  get isSidebar(): boolean {
    return this.layoutSubject.value === 'sidebar';
  }

  setLayout(type: LayoutType): void {
    this.layoutSubject.next(type);
  }
}
